<template>
  <div>
    <template v-if="isMarkdown(message)">
      <div class="msg-markdown-text" v-html="renderMarkdown(message.content)"></div>
    </template>
    <template v-else>
      <span class="msg-text">{{message.content}}</span>
      <span v-if="message.loading" class="msg-loading"><van-loading size="18px" /></span>
    </template>
  </div>
</template>

<script>
  import markdownit from 'markdown-it'

  const md = markdownit()

  const markHtmlTagReg = /<(h[1-6]|ul|ol|li|a|pre|code|table|blockquote|strong|em|img)>?/

  export default {
    props: {
      message: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {}
    },
    methods: {
      isMarkdown(message = {}) {
        if (message.mark) {
          return true
        }

        try {
          const html = md.render(message.content)
          if (markHtmlTagReg.test(html)) {
            message.mark = true
            return true
          } else {
            return false
          }
        } catch (error) {
          message.mark = false
          return false
        }
      },
      renderMarkdown(str) {
        md.renderer.rules.table_open = (tokens, idx, options, env, self) => {
          return '<div class="table-scroll-wrapper scrollbar-width-none">' +
            '<div class="table-scroll-container">' + self.renderToken(tokens, idx, options)
        }

        md.renderer.rules.table_close = (tokens, idx, options, env, self) => {
          return self.renderToken(tokens, idx, options) + '</div></div>'
        }

        // md.renderer.rules.image_open = (tokens, idx, options, env, self) => {
        //   return '<div class="markdown-image-wrapper">' + self.renderToken(tokens, idx, options)
        // }

        // md.renderer.rules.image_close = (tokens, idx, options, env, self) => {
        //   return self.renderToken(tokens, idx, options) + '</div>'
        // }

        md.renderer.rules.image = (tokens, idx, options, env, self) => {
          const token = tokens[idx]
          token.attrSet('class', 'markdown-image')

          return '<div class="markdown-image-wrapper">' + self.renderToken(tokens, idx, options, env, self) + '</div>'
        }

        return md.render(str)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .msg-text {
    font-size: 15px;
    /* line-height: 30px; */
    color: rgba(0,0,0,0.65);
    white-space: pre-wrap;
  }
  .msg-loading {
    display: inline-block;
    vertical-align: middle;
  }
  .msg-markdown-text {
    font-size: 15px;
    color: rgba(0,0,0,0.65);
    white-space: normal;
    /deep/ * {
      padding: 0;
      margin: 4px 0;
      box-sizing: border-box;
      word-break: break-all;
      font-size: 15px;
      /* line-height: 30px; */
    }
    /deep/ a {
      &:link, &:visited, &:hover, &:active {
        color: #0000EE
      }
    }
    /deep/ img {
      display: block;
    }
    /deep/ ol, ul {
      list-style: inside;
    }
    /deep/ .table-scroll-wrapper {
      max-width: 100%;
      overflow-x: auto;
      width: fit-content;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      border: 0.5px solid #d8dee4;
      border-top: 0;
      border-radius: 8px;
      margin: 0;
      .table-scroll-container {
        flex: 1 0 auto;
        margin: 0;
        box-sizing: border-box;
      }
      table {
        border-collapse: collapse;
        margin: 0;
        thead tr:first-child {
          background: #f7f7f7;
        }
        tr {
          border-top: 0.5px solid #d8dee4;
          background: #FBFBFB;
        }
        td, th {
          min-width: 100px;
          max-width: 400px;
          border: 0;
          padding: 8px 12px;
        }
      }
    }

    /deep/ .markdown-image-wrapper {
      contain: strict; /* 隔离渲染层级 */
      position: relative;
      width: 100%;
      max-width: 255px;
      padding-top: 56.25%; /* 16:9比例 */
      background: #ffffff;
      .markdown-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        margin: 0;
      }
    }
  }
</style>
